export function arrayMove<T>(
  array: T[],
  fromIndex: number,
  toIndex: number
): T[] {
  const item = array[fromIndex];
  return array.toSpliced(fromIndex, 1).toSpliced(toIndex, 0, item);
}
